import { useMutation, useQuery, useQueryClient } from 'react-query';
import axios from 'axios';
import { CompanyFiscal } from '../models/companyFiscal';

const apiUrl = process.env.REACT_APP_BASIX_API || '';

const getFiscal = async (): Promise<CompanyFiscal> => {
  const { data } = await axios.get(`${apiUrl}settings/Fiscal`);
  return data;
};

const useCompanyFiscal = () => {
  const queryClient = useQueryClient();
  const query = useQuery('companyFiscal', getFiscal);

  const mutation = useMutation(
    (fiscal: CompanyFiscal) => axios.post(`${apiUrl}settings/Fiscal`, fiscal),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('companyFiscal');
      },
    },
  );

  return {
    ...query,
    fiscal: query.data,
    tryUpdate: mutation.mutateAsync,
    isSaving: mutation.isLoading,
  };
};

export default useCompanyFiscal;
